import ClampedParagraph from './ClampedParagraph';

export default ClampedParagraph;
